/**
    @objc func trackAdvertAction(action: String, advertName: String, advertCategory: String, id: String, advertCategoryId: String) {
    }
    @objc func trackAdvertCategory(category: String, id: String) {
    }
    @objc func trackAdvertView(category: String, name: String, id: String, advertCategoryId: String) {
    }
    @objc func trackAdvertCategoryAction(category: String, categoryId: String, advertName: String, advertId: String, action: String) {
    }
 */
import { NativeModules } from 'react-native';

import { NewsItem, Advertisement, Gallery } from '../../api/adserver';

const debug = require('debug')('se:analytics');

function trackAdvertAction(
  action: string,
  advertName: string,
  advertCategory: string,
  id: string,
  advertCategoryId: string,
) {
  setTimeout(() => {
    debug(`track advert action: ${action}, for advert:${advertName}`);
    if (NativeModules.RNAction && NativeModules.RNAction.trackAdvertAction) {
      NativeModules.RNAction.trackAdvertAction(
        action,
        advertName,
        advertCategory,
        id,
        advertCategoryId,
      );
    } else {
      // console.warn('no NativeModules.RNAction.trackAdvertAction');
    }
  }, 10);
}

function trackAdvertCategory(category: string, id: string) {
  setTimeout(() => {
    if (NativeModules.RNAction && NativeModules.RNAction.trackAdvertCategory) {
      NativeModules.RNAction.trackAdvertCategory(category, id);
    } else {
      // console.warn('no NativeModules.RNAction.trackAdvertCategory');
    }
  }, 10);
}

function trackAdvertView(advert: Advertisement) {
  setTimeout(() => {
    if (NativeModules.RNAction && NativeModules.RNAction.trackAdvertView) {
      if (!advert.campaign) {
        return;
      }
      const advertiserId = advert.advertiser.id.toString();
      const advertiserName = advert.advertiser.name;
      const categoryName = advert.categories[0].title;
      const categoryId = advert.categories[0].id.toString();
      const campaignName = advert.campaign?.name;
      const campaignId = advert.campaign?.id.toString();
      const name = advert.headline;
      const id = advert.id.toString();
      debug(`track advert view: ${advert.headline}`);
      NativeModules.RNAction.trackAdvertView(
        id,
        name,
        categoryId,
        categoryName,
        advertiserId,
        advertiserName,
        campaignId,
        campaignName,
      );
    } else {
      // console.warn('no NativeModules.RNAction.trackAdvertView');
    }
  }, 10);
}

function trackAdvertDetailView(advert: Advertisement) {
  setTimeout(() => {
    if (
      NativeModules.RNAction &&
      NativeModules.RNAction.trackAdvertDetailView
    ) {
      if (!advert.campaign) {
        return;
      }
      const advertiserId = advert.advertiser.id.toString();
      const advertiserName = advert.advertiser.name;
      const categoryName = advert.categories[0].title;
      const categoryId = advert.categories[0].id.toString();
      const campaignName = advert.campaign?.name;
      const campaignId = advert.campaign?.id.toString();
      const name = advert.headline;
      const id = advert.id.toString();
      debug(`track advert details view: ${advert.headline}`);
      NativeModules.RNAction.trackAdvertDetailView(
        id,
        name,
        categoryId,
        categoryName,
        advertiserId,
        advertiserName,
        campaignId,
        campaignName,
      );
    } else {
      // console.warn('no NativeModules.RNAction.trackAdvertDetailView');
    }
  }, 10);
}

function trackAdvertCategoryAction(
  category: string,
  categoryId: string,
  advertName: string,
  advertId: string,
  action: string,
) {
  setTimeout(() => {
    if (
      NativeModules.RNAction &&
      NativeModules.RNAction.trackAdvertCategoryAction
    ) {
      NativeModules.RNAction.trackAdvertCategoryAction(
        category,
        categoryId,
        advertName,
        advertId,
        action,
      );
    } else {
      // console.warn('no NativeModules.RNAction.trackAdvertCategoryAction');
    }
  }, 10);
}

function trackScreenView(screenName: string) {
  setTimeout(() => {
    if (NativeModules.RNAction && NativeModules.RNAction.trackScreenView) {
      NativeModules.RNAction.trackScreenView(screenName);
    } else {
      // console.warn('no NativeModules.RNAction.trackScreenView');
    }
  }, 10);
}

function trackSearch(screenName: string) {
  // set timeout after submission and don't send again until after timeout.
  // updates override existing buffer
  setTimeout(() => {
    if (NativeModules.RNAction && NativeModules.RNAction.trackScreenView) {
      NativeModules.RNAction.trackScreenView(screenName);
    } else {
      // console.warn('no NativeModules.RNAction');
    }
  }, 10);
}

function trackNewsDetailView(news: NewsItem) {
  setTimeout(() => {
    if (NativeModules.RNAction && NativeModules.RNAction.trackNewsDetailView) {
      if (!news) {
        return;
      }
      const newsId = news.id.toString();
      const newsName = news.title;
      debug(`track news details view: ${news.title}`);
      NativeModules.RNAction.trackNewsDetailView(newsId, newsName);
    } else {
      // console.warn('no NativeModules.RNAction.trackNewsDetailView');
    }
  }, 10);
}

function trackingGalleryView(gallery: Gallery) {
  setTimeout(() => {
    if (NativeModules.RNAction && NativeModules.RNAction.trackingGalleryView) {
      if (!gallery) {
        return;
      }
      const galleryId = gallery.id.toString();
      const galleryTitle = gallery.title;
      debug(`track gallery details view: ${gallery.title}`);
      NativeModules.RNAction.trackingGalleryView(galleryId, galleryTitle);
    } else {
      // console.warn('no NativeModules.RNAction.trackingGalleryView');
    }
  }, 10);
}

export {
  trackAdvertAction,
  trackAdvertCategory,
  trackAdvertView,
  trackAdvertDetailView,
  trackAdvertCategoryAction,
  trackScreenView,
  trackSearch,
  trackNewsDetailView,
  trackingGalleryView,
};
